import React from "react";
function Sport(){
    return(<>Sport</>)
}
export default Sport;